export default __webpack_public_path__ + "static/media/header.75bbcc40.svg";